import React from "react";
import PropTypes from "prop-types";
import OfferDetails from "../OfferDetails";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const StepSummary = props => {
    const {homes, formik} = props;
    const {
        titleIt,
        titleEn,
        descriptionIt,
        descriptionEn,
        startDate,
        endDate,
        price,
        minPeople,
        minNight,
        petsAllowed,
        apartmentId,
    } = formik.values;

    let home;
    let apartment;

    for (let h of homes) {
        for (let a of h["apartments"]) {
            if (a["id"] === apartmentId) {
                home = h;
                apartment = a;
            }
        }
    }

    const pictureUrl = home && home["icon"] ? home["icon"] : null;
    const homeName = home && home["name"] ? home["name"] : "HOME_NAME";
    const apartmentName = apartment && apartment["name"] ? apartment["name"] : "APARTMENT_NAME";

    return (
        <React.Fragment>
            <Typography variant="h6">
                Verifica
            </Typography>
            <Box sx={{my: 4}}>
                <OfferDetails titleIt={titleIt}
                              titleEn={titleEn}
                              descriptionIt={descriptionIt}
                              descriptionEn={descriptionEn}
                              startDate={startDate}
                              endDate={endDate}
                              price={parseFloat(price)}
                              minPeople={minPeople}
                              minNight={minNight}
                              petsAllowed={petsAllowed}
                              pictureUrl={pictureUrl}
                              homeName={homeName}
                              apartmentName={apartmentName}/>
            </Box>
        </React.Fragment>
    )
};

StepSummary.propTypes = {
    homes: PropTypes.arrayOf(PropTypes.object).isRequired,
    formik: PropTypes.object.isRequired,
};

export default StepSummary;